import type { CustomRouteContext } from 'core/universalRouter/types';
import { REQUEST_FROM } from 'store/reviewList/types';
import { fetchSEOData } from 'store/seo/action';

import { fetchProfileById } from 'store/profileById/actions';
import { setIsViewingOtherUser } from 'store/profileById/slice';
import { fetchReviewList } from 'store/reviewList/actions';
import { fetchDefaultSNSList } from 'store/snsDefaultList/actions';
import { fetchUserProfile } from 'store/userProfile/actions';
import { MY_REVIEW_PAGE } from 'utils/ratHelper';

import { REVIEW_LIST_LOAD_MORE_LIMIT } from 'constants/common';

import type { RouteContext } from 'universal-router';
import type { RootAction, Store } from 'react-redux';
import type { SortBy } from 'store/reviewList/types';
export type URLParams = {
  userId?: string;
};

export default async function myReviewPageResolver(
  context: RouteContext<CustomRouteContext>,
  store: Store,
): Promise<void> {
  const params = context.params as URLParams;

  const { dispatch, getState } = store;
  const isLoggedIn = Boolean(getState().authCode?.item?.token);
  const loggedInUser = getState().authCode.loggedInUser;
  let userId: string | undefined;
  let reviewCount: number | undefined;

  if (params.userId) {
    dispatch(setIsViewingOtherUser(true));
    const action: RootAction = await dispatch(fetchProfileById(params.userId));

    userId = action.payload.userId;
    reviewCount = action.payload.reviewCount;
  } else if (isLoggedIn) {
    userId = loggedInUser?.userId;
    const action: RootAction = await dispatch(fetchUserProfile());

    reviewCount = action.payload.reviewCount;
  }

  const userReviewQuery = {
    sortBy: MY_REVIEW_PAGE as SortBy,
    offset: 0,
    limit: REVIEW_LIST_LOAD_MORE_LIMIT,
    userId: userId,
    requestFrom: REQUEST_FROM.MY_REVIEW,
  };

  dispatch(fetchDefaultSNSList());

  if (reviewCount && reviewCount > 0) await dispatch(fetchReviewList(userReviewQuery));
  dispatch(fetchSEOData({ pageName: MY_REVIEW_PAGE }));
}
